import { Controller } from "@hotwired/stimulus";

export default class ContactFormStatusController extends Controller {
  static targets = ["toggle", "input", "button", "indicator", "label", "disabledMessage"];

  toggle() {
    const currentValue = this.inputTarget.value === "true";
    const newValue = !currentValue;

    this.inputTarget.value = newValue ? "true" : "false";

    // State is inverted: checked means enabled (is_disabled=false)
    const newState = newValue ? "unchecked" : "checked";
    this.buttonTarget.setAttribute("data-state", newState);
    this.buttonTarget.setAttribute("aria-checked", !newValue);
    this.indicatorTarget.setAttribute("data-state", newState);

    this.labelTarget.textContent = newValue ? "Contact Form Disabled" : "Contact Form Enabled";

    if (newValue) {
      this.disabledMessageTarget.classList.remove("hidden");
    } else {
      this.disabledMessageTarget.classList.add("hidden");
    }
  }
}
